import type { RouterOptions } from '@nuxt/schema';

export default <RouterOptions>{
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        setTimeout(() => {
          const container = document.querySelector('.content')
          if (container) {
            container.scrollTo({ top: 0, behavior: 'smooth' })
          } else {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }
          resolve({ left: 0, top: 0 })
        }, 50)
      })
    })
  },
};
